import { useParams } from "react-router";
import t from "@/lang/lang";
import { useQpmOfferShowQuery } from "@/services/backend/qpm/offers/api/offer-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { Separator } from "@/shared/components/ui/separator";
import { Skeleton } from "@/shared/components/ui/skeleton";
import { OfferServiceProgramEditor } from "@/routes/processes/[processId]/qpm/offers/[offerId]/service-program/_components/offer-service-program-editor";

export function OfferServiceProgramRoute() {
  const params = useParams();
  const { offerId } = params;
  const {
    data: offer,
    isLoading,
    error,
  } = useQpmOfferShowQuery({ id: offerId! }, { skip: !offerId });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card>
        <CardHeader className="space-y-3 px-4 py-4 sm:px-6">
          <Skeleton className="h-7 w-64" />
          <Separator />
        </CardHeader>
        <CardContent className="space-y-4 px-4 pb-6 sm:px-6">
          <Skeleton className="h-40 w-full" />
          <Skeleton className="h-72 w-full" />
        </CardContent>
      </Card>
    );
  }

  if (!offer) {
    return null;
  }

  return (
    <Card className="overflow-hidden">
      <CardHeader className="bg-muted/20 space-y-3 px-4 py-4 sm:px-6">
        <CardTitle className="text-lg font-semibold sm:text-xl">
          {t("Leistungsprogramm")}
        </CardTitle>
        <Separator />
      </CardHeader>
      <CardContent className="space-y-6 px-4 py-5 sm:px-6">
        <section className="space-y-4 rounded-lg border p-4 sm:p-5">
          <OfferServiceProgramEditor offer={offer} />
        </section>
      </CardContent>
    </Card>
  );
}
